import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#c06ec8",
      d: "m15.07 10.75-1.008 1.01 4.16 4.16s.049.135 0 .185l-4.148 4.147 1.01 1.01 4.147-4.148a1.553 1.553 0 0 0 0-2.19l-4.16-4.16v-.013Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#c06ec8",
      "fill-rule": "evenodd",
      d: "M29 16c0-7.18-5.82-13-13-13S3 8.82 3 16s5.82 13 13 13 13-5.82 13-13Zm1 0c0-7.732-6.268-14-14-14S2 8.268 2 16s6.268 14 14 14 14-6.268 14-14Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-purple"}) } }